export default __webpack_public_path__ + "static/media/coin_busd.57b99571.svg";